export interface ValidationResult {
  isValid: boolean;
  errors: string[];
}

export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function validatePassword(password: string): ValidationResult {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push("Password must be at least 8 characters long");
  }

  if (!/[A-Z]/.test(password)) {
    errors.push("Password must contain at least one uppercase letter");
  }

  if (!/[a-z]/.test(password)) {
    errors.push("Password must contain at least one lowercase letter");
  }

  if (!/\d/.test(password)) {
    errors.push("Password must contain at least one number");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

export function validateDomainPrefix(prefix: string): ValidationResult {
  const errors: string[] = [];

  if (!prefix.trim()) {
    errors.push("Domain prefix is required");
  } else {
    // Only allow lowercase letters, numbers, and hyphens
    if (!/^[a-z0-9-]+$/.test(prefix)) {
      errors.push("Domain prefix can only contain lowercase letters, numbers, and hyphens");
    }

    // Must start and end with a letter or number
    if (!/^[a-z0-9]/.test(prefix) || !/[a-z0-9]$/.test(prefix)) {
      errors.push("Domain prefix must start and end with a letter or number");
    }

    // Minimum length
    if (prefix.length < 3) {
      errors.push("Domain prefix must be at least 3 characters long");
    }

    // Maximum length
    if (prefix.length > 63) {
      errors.push("Domain prefix must be less than 63 characters");
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

export function validatePhone(phone: string): ValidationResult {
  const errors: string[] = [];

  if (phone && phone.trim()) {
    // Remove common formatting characters
    const cleaned = phone.replace(/[\s\-()]/g, "");
    // Check if it's a valid phone number (at least 10 digits)
    if (!/^\d{10,15}$/.test(cleaned)) {
      errors.push("Please enter a valid phone number");
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

export function validateRequired(value: string, fieldName: string): ValidationResult {
  const errors: string[] = [];

  if (!value || !value.trim()) {
    errors.push(`${fieldName} is required`);
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}
